module.exports = __webpack_public_path__ + "img/c02_unitpriestessofra_Normal_ua.1344ed69.webp";